import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../helpers/request';
import { keyPermitDoc } from './usePermitDocuments';

const addDoc = async ({ permitId, file }) => {
  const formData = new FormData();
  formData.append('file', file);

  return await request.post(
    `/Access/transport/${permitId}/attachments`,
    formData,
    `При загрузке файла ${file.name} произошла ошибка`,
    'Error'
  );
};

const useAddDoc = () => {
  const queryClient = useQueryClient();

  return useMutation(addDoc, {
    onSuccess: (data, { permitId }) => {
      if (data === 'Error') return;

      queryClient.refetchQueries(keyPermitDoc(permitId));
    },
  });
};

export default useAddDoc;
